<template>
	<div ref="tooltipHelper" class="helper-tooltip" :style="positions">
		<div class="helper-tooltip__content">
			<div class="helper-tooltip__pointer" :class="pointerPosition"></div>
			<h1 class="text--center body-text-1 mb--2">
				{{ $t(tooltipContent) }}
			</h1>
			<button v-if="isButtonVisible" class="btn btn-link" @click="moveToNext()">
				{{ $t(buttonText) }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		steps: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			panelX: 0,
			panelY: 0,
			currentStep: 0,
			tooltipContent: '',
			pointerPositions: {
				left: 'right',
				top: 'bottom',
				bottom: 'top',
				right: 'left'
			}
		};
	},
	computed: {
		positions() {
			if (!this.panelX && !this.panelY) {
				return {};
			}

			return {
				// 20 is tooltip pointer
				left: `${this.panelX}px`,
				top: `${this.panelY}px`,
				transform: 'none'
			};
		},
		isLastTooltip() {
			return this.steps.length === this.currentStep + 1;
		},
		isButtonVisible() {
			return !!this.steps[this.currentStep + 1] || this.isLastTooltip;
		},
		currentSelector() {
			return this.steps[this.currentStep].selector || '';
		},
		buttonText() {
			return this.isLastTooltip ? 'finish' : 'next';
		},
		tooltipPosition() {
			return this.steps[this.currentStep].position || 'center';
		},
		pointerPosition() {
			return this.pointerPositions[this.tooltipPosition]
				? `pointer--${this.pointerPositions[this.tooltipPosition]}`
				: '';
		}
	},
	watch: {
		currentSelector() {
			this.updatePosition();
			this.updateContent();
		}
	},
	mounted() {
		this.updateContent();
	},
	methods: {
		moveToNext() {
			if (!this.isLastTooltip) {
				this.currentStep++;
			} else {
				this.$emit('closeHelper');
			}
		},
		updatePosition() {
			const element = document.querySelector(
				`[tutorial-id="${this.currentSelector}"]`
			);

			if (element && this.currentSelector) {
				const currentRef = this.$refs.tooltipHelper.getBoundingClientRect();
				const elementBox = element.getBoundingClientRect();

				// TODO: UPDATE THIS TO WOKR WITH position: left and bottom
				if (this.tooltipPosition === 'right') {
					this.panelX = elementBox.right + 20;
					this.panelY = elementBox.top - currentRef.height / 2;
				}

				if (this.tooltipPosition === 'top') {
					this.panelX = elementBox.left;
					this.panelY = elementBox.top - currentRef.height - 20;
				}
			} else {
				// reset position
				this.panelX = 0;
				this.panelY = 0;
			}
		},
		updateContent() {
			this.tooltipContent = this.steps[this.currentStep].textKey || '';
		},
		mapCoordinates() {
			switch (this.tooltipPosition) {
				case 'top':
					return { x: 'left', y: 'top' };
				case 'right':
					return { x: 'right', y: 'top' };
				case 'bottom':
					return { x: 'left', y: 'top' };
				case 'left':
					return { x: 'left', y: 'top' };
				default:
					break;
			}
		}
	}
};
</script>

<style scoped lang="scss">
// TODO: move this in global SCSS scope to reuse it
.helper-tooltip {
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	position: absolute;
	border-radius: 8px;
	z-index: 999;
	min-width: 300px;
	max-width: 360px;
	min-height: 150px;
	padding: 24px;
	box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);
	background-color: $container-bgcolor;

	&__content {
		display: flex;
		flex-direction: column;
	}

	&__pointer {
		width: 16px;
		height: 16px;
		transform: rotate(45deg);
		position: absolute;
		background-color: $container-bgcolor;
	}

	.pointer {
		&--left {
			top: 0;
			bottom: 0;
			left: -8px;
			margin: auto;
			border-left: 1px solid $container-border;
			border-bottom: 1px solid $container-border;
		}

		&--right {
			top: 0;
			bottom: 0;
			right: -8px;
			margin: auto;
			border-right: 1px solid $container-border;
			border-top: 1px solid $container-border;
		}

		&--bottom {
			bottom: -8px;
			border-right: 1px solid $container-border;
			border-bottom: 1px solid $container-border;
		}
	}
}
</style>
